module.exports = __webpack_public_path__ + "img/2.4a898d84.png";